import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sixth-page',
  templateUrl: './sixth-page.component.html',
  styleUrls: ['./sixth-page.component.css']
})
export class SixthPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
